import { render, staticRenderFns } from "./ListHeader.vue?vue&type=template&id=35b22a8a&scoped=true&"
import script from "./ListHeader.vue?vue&type=script&lang=js&"
export * from "./ListHeader.vue?vue&type=script&lang=js&"
import style0 from "./ListHeader.vue?vue&type=style&index=0&id=35b22a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b22a8a",
  null
  
)

export default component.exports